import { render, staticRenderFns } from "./TradesTableClassic.vue?vue&type=template&id=1a016ec2&"
import script from "./TradesTableClassic.vue?vue&type=script&lang=js&"
export * from "./TradesTableClassic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports